import { render } from "./Content_factions.vue?vue&type=template&id=424e33a5&scoped=true"
import script from "./Content_factions.vue?vue&type=script&lang=js"
export * from "./Content_factions.vue?vue&type=script&lang=js"

import "./Content_factions.vue?vue&type=style&index=0&id=424e33a5&scoped=true&lang=css"

import exportComponent from "/Users/news/Desktop/source/topic_freddy/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-424e33a5"]])